import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonsEntityTypesComponent } from './persons-entity-types.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { EditEntityComponent } from './edit-entity/edit-entity.component';
import { AddEntityComponent } from './add-entity/add-entity.component';

@NgModule({
    declarations: [
        PersonsEntityTypesComponent,
        EditEntityComponent,
        AddEntityComponent,
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [
        PersonsEntityTypesComponent,
    ],
})
export class PersonsEntityTypesModule { }
